module.exports = __webpack_public_path__ + "img/9.6231c9a7.jpg";